import React from 'react';
import { BaseButton, ButtonSize, NativeButtonProps } from './BaseButton';

type Props = NativeButtonProps & { size?: ButtonSize };

export const NegativeButton = (props: Props) => <BaseButton buttonStyle="negative" {...props} />;
